/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


  const timerEnabled = $('.AnnouncementBar').attr('data-timer');
  
  if(timerEnabled == 'enabled'){
    setInterval(function time(){
      let endsIn = $('#finalCountdown').attr('data-ends');
      
      endsIn = parseInt(endsIn);
      
      let days = endsIn * 24;
      
      var d = new Date();
      var hours = days - d.getHours();
      var min = 60 - d.getMinutes();

      if((hours + '').length == 1){
        hours= '0' + hours;
      }
      if((min + '').length == 1){
        min = '0' + min;
      }

      var sec = 60 - d.getSeconds();
      if((sec + '').length == 1){
        sec = '0' + sec;
      }

      var ht = '<span class="timeHours"><div class="timeNum">'+hours+'</div><div class="timeTxt">H</div></span> <span class="dots">:</span> ';
      ht += '<span class="timeMins"><div class="timeNum">'+min+'</div><div class="timeTxt">M</div></span> <span class="dots">:</span> ';
      ht += '<span class="timeSec"><div class="timeNum">'+sec+'</div><div class="timeTxt">S</div></span>';
      $('#finalCountdown').html(ht);
      $('.AnnouncementBar__timer').css('opacity',1);
      
    }, 1000);
  }